export const BIRTHDAY_EMAIL_FREQUENCY_OPTIONS = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'disabled', label: 'Disabled' },
];

export const BIRTHDAY_EMAIL_MAXIMUM_BIRTHDAYS = [
    { value: 0, label: 'No Limit' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
];

export const BIRTHDAY_EMAIL_REMINDER_TIME = [
    { value: 1, label: '1 day before' },
    { value: 3, label: '3 days before' },
    { value: 5, label: '5 days before' },
];

export const BIRTHDAY_EMAIL_CONTACT_TYPES = [
    { value: 'both', label: 'Both personal and professional' },
    { value: 'personal', label: 'Personal' },
    { value: 'professional', label: 'Professional' },
];

export const BIRTHDAY_EMAIL_SORT = [
    { value: 'circle', label: 'By Closeness' },
    { value: 'date', label: 'By Date' },
];
